import useDocumentTitle from '../hooks/useDocumentTitle';
import PropTypes from 'prop-types';

const Title = ({ title }) => {
    useDocumentTitle(title);
    return <></>;
};

Title.propTypes = {
    title: PropTypes.string
};

export default Title;
